const driveSeriveName = "/Drive"
export function driveService (http) {
    return{
        // getDrive: async (driveId) => {
        //     let parameters = {
        //         Id: driveId
        //     };
        //     return await http.post(driveSeriveName + '/GetDriveAsync', parameters);
        // },
        // getDriveFoldersAsync: async (driveId) => {
        //     let parameters = {
        //         Id: driveId
        //     };
        //     return await http.post(driveSeriveName + '/GetDriveFoldersAsync', parameters);
        // }

    }
}